import { ServiceLayout } from "@/components/service/ServiceLayout";
import { ServiceFAQ } from "@/components/service/ServiceFAQ";
import { UXUIHero } from "@/components/ux-ui/HeroSection";
import { DesignProcess } from "@/components/ux-ui/DesignProcess";
import { ServicesShowcase } from "@/components/ux-ui/ServicesShowcase";
import { ProcessSection } from "@/components/ux-ui/ProcessSection";
import { ServiceCTA } from "@/components/ui/ServiceCTA";
import { serviceFAQs } from "@/data/service-faqs";

const UXUIDesign = () => {
  return (
    <ServiceLayout serviceName="UX/UI Design">
      <UXUIHero />
      <DesignProcess />
      <ServicesShowcase />
      <ProcessSection />
      <ServiceFAQ faqs={serviceFAQs["ux-ui"]} serviceName="UX/UI Design" />
      <ServiceCTA serviceName="UX/UI Design" />
    </ServiceLayout>
  );
};

export default UXUIDesign;